import {
   ADD_CUSTOMER_REGISTOR,
   ADD_ORDER,
   GET_DASHBOARD_COUNT,
   GET_GLOBAL_SETTING,
   GET_PACKAGE,
   GET_PACKAGE_CUSTOMER,
   GET_SETTING_FOR_WEB,
   UPDATE_PACKAGE_CUSTOMER,
   VALIDATE_CUSTOMER,
} from '../types';

const initialState = {
   list: [],
   pagination: {},
   totalCount: 0,
};

const reducer = (state = initialState, action) => {
   const { type, payload } = action;
   switch (type) {
      case GET_PACKAGE:
         return {
            ...state,
            list: payload.data || [],
            pagination: payload.pagination || {},
            totalCount: payload.totalCount || 0,
         };
      case ADD_CUSTOMER_REGISTOR:
         return {
            ...state,
            list: [...state.list, action.payload],
            loading: false,
            success: true,
            error: null,
         };
      case VALIDATE_CUSTOMER:
         return {
            ...state,
            list: [...state.list, action.payload],
            loading: false,
            success: true,
            error: null,
         };
      case GET_DASHBOARD_COUNT:
         return {
            ...state,
            dashboardCount: payload.data || [],
         };

      case GET_SETTING_FOR_WEB:
         return {
            ...state,
            webSetting: payload.data || [],
         };

      case ADD_ORDER:
         return {
            ...state,
            list: [...state.list, action.payload],
         };
      case GET_GLOBAL_SETTING:
         return {
            ...state,
            globalSetting: payload.data || [],
         };
      case GET_PACKAGE_CUSTOMER:
         return {
            ...state,
            packageCustomer: payload.data || [],
         };

      case UPDATE_PACKAGE_CUSTOMER:
         return {
            ...state,
            packageCustomer: state.list.map((item) => (item.id === payload.id ? payload : item)),
         };
      default:
         return state;
   }
};

export default reducer;
